import { withNavigation } from "../../Common/withNavigation";
import { connect } from "react-redux";
import AnalyticsPage from "../Analytics/Analytics";
import { getTopsellingProductRequest } from "./Analytics-slice";

const mapStateToProps = (state) => {
//   console.log(
//     "Analytics Data---->",
//     state.Analytics.getTopsellingProductdata?.top_selling
//   );
  return {
    TopsellingProduct: state.Analytics.getTopsellingProductdata?.top_selling,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTopsellingProductRequest: () => dispatch(getTopsellingProductRequest()),
  };
};

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps)(AnalyticsPage)
);
